@if (animationType == 1) {
  <div>
    <div>
      @switch (animationDirection) {
        @case (1) {
          <img src="/assets/img/vPlaybook-logo_color_sm.png" style="width: 165px; object-fit: scale-down;"
            [@bounceIn]="animationState">
        }
        @case (2) {
          <img src="/assets/img/vPlaybook-logo_color_sm.png" style="width: 165px; object-fit: scale-down;"
            [@bounceInDown]="animationState">
        }
        @case (3) {
          <img src="/assets/img/vPlaybook-logo_color_sm.png" style="width: 165px; object-fit: scale-down;"
            [@bounceInLeft]="animationState">
        }
        @case (4) {
          <img src="/assets/img/vPlaybook-logo_color_sm.png" style="width: 165px; object-fit: scale-down;"
            [@bounceInRight]="animationState">
        }
        @case (5) {
          <img src="/assets/img/vPlaybook-logo_color_sm.png" style="width: 165px; object-fit: scale-down;"
            [@bounceInUp]="animationState">
        }
        @default {
          <img src="/assets/img/vPlaybook-logo_color_sm.png" style="width: 165px; object-fit: scale-down;">
        }
      }
    </div>
  </div>
}

@if (animationType == 2) {
  <div>
    <div>
      @switch (animationDirection) {
        @case (1) {
          <img src="/assets/img/vPlaybook-logo_color_sm.png" style="width: 165px; object-fit: scale-down;"
            [@fadeIn]="animationState">
        }
        @case (2) {
          <img src="/assets/img/vPlaybook-logo_color_sm.png" style="width: 165px; object-fit: scale-down;"
            [@fadeInDown]="animationState">
        }
        @case (3) {
          <img src="/assets/img/vPlaybook-logo_color_sm.png" style="width: 165px; object-fit: scale-down;"
            [@fadeInLeft]="animationState">
        }
        @case (4) {
          <img src="/assets/img/vPlaybook-logo_color_sm.png" style="width: 165px; object-fit: scale-down;"
            [@fadeInRight]="animationState">
        }
        @case (5) {
          <img src="/assets/img/vPlaybook-logo_color_sm.png" style="width: 165px; object-fit: scale-down;"
            [@fadeInUp]="animationState">
        }
        @default {
          <img src="/assets/img/vPlaybook-logo_color_sm.png" style="width: 165px; object-fit: scale-down;">
        }
      }
    </div>
  </div>
}

@if (animationType == 3) {
  <div>
    <div>
      @switch (animationDirection) {
        @case (2) {
          <img src="/assets/img/vPlaybook-logo_color_sm.png" style="width: 165px; object-fit: scale-down;"
            [@fadeInDownBig]="animationState">
        }
        @case (3) {
          <img src="/assets/img/vPlaybook-logo_color_sm.png" style="width: 165px; object-fit: scale-down;"
            [@fadeInLeftBig]="animationState">
        }
        @case (4) {
          <img src="/assets/img/vPlaybook-logo_color_sm.png" style="width: 165px; object-fit: scale-down;"
            [@fadeInRightBig]="animationState">
        }
        @case (5) {
          <img src="/assets/img/vPlaybook-logo_color_sm.png" style="width: 165px; object-fit: scale-down;"
            [@fadeInUpBig]="animationState">
        }
        @default {
          <img src="/assets/img/vPlaybook-logo_color_sm.png" style="width: 165px; object-fit: scale-down;">
        }
      }
    </div>
  </div>
}

@if (animationType == 4) {
  <div>
    <div>
      @switch (animationDirection) {
        @case (1) {
          <img src="/assets/img/vPlaybook-logo_color_sm.png" style="width: 165px; object-fit: scale-down;"
            [@zoomIn]="animationState">
        }
        @default {
          <img src="/assets/img/vPlaybook-logo_color_sm.png" style="width: 165px; object-fit: scale-down;">
        }
      }
    </div>
  </div>
}

@if (animationType == 5) {
  <div>
    <div>
      @switch (animationDirection) {
        @case (4) {
          <img src="/assets/img/vPlaybook-logo_color_sm.png" style="width: 165px; object-fit: scale-down;"
            [@flipInX]="animationState">
        }
        @case (5) {
          <img src="/assets/img/vPlaybook-logo_color_sm.png" style="width: 165px; object-fit: scale-down;"
            [@flipInY]="animationState">
        }
        @default {
          <img src="/assets/img/vPlaybook-logo_color_sm.png" style="width: 165px; object-fit: scale-down;">
        }
      }
    </div>
  </div>
}

@if (animationType == 6) {
  <div>
    <div>
      @switch (animationDirection) {
        @case (1) {
          <img src="/assets/img/vPlaybook-logo_color_sm.png" style="width: 165px; object-fit: scale-down;"
            [@flash]="animationState">
        }
        @default {
          <img src="/assets/img/vPlaybook-logo_color_sm.png" style="width: 165px; object-fit: scale-down;">
        }
      }
    </div>
  </div>
}
@if (!animationType) {
  <img src="/assets/img/vPlaybook-logo_color_sm.png" style="width: 165px; object-fit: scale-down;">
}